import { TramitType } from '@/interfaces/files';
import { Affiliate } from '@/interfaces/affiliates';

import { getTramitTypes } from '@/services/files.service';
import { getMyAffiliates } from '@/services/user.service';
import { Effect, Reducer } from '@umijs/max';

export interface ModelType {
  namespace: string;
  state: { tramitsTypes: TramitType[]; affiliates: Affiliate[] };
  effects: {
    fetchData: Effect;
  };
  reducers: {
    setData: Reducer<any>;
  };
}

const Model: ModelType = {
  namespace: 'tramitList',

  state: {
    affiliates: [],
    tramitsTypes: [],
  },

  effects: {
    *fetchData({ payload }, { call, put, all }) {
      const [tramitsTypes, affiliates] = yield all([
        call(getTramitTypes, payload),
        call(getMyAffiliates, payload),
      ]);
      yield put({
        type: 'setData',
        payload: {
          tramitsTypes: tramitsTypes.data,
          affiliates: affiliates.data,
        },
      });
    },
  },

  reducers: {
    setData(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};

export default Model;
